export default {
  data() {
    return {
      showLowBalanceDialog: false,
    }
  },
  methods: {
    async changeOrganisation(newOrg, oldOrg, overlay = true) {
      if ( overlay ) {
        this.$root.$emit('showOverlay', 'changeOrganisation')
      }
      try {
        if (newOrg?.organizationItId != oldOrg?.organizationItId && oldOrg) {
          this.$store.dispatch('clearObjectData', { acl: this.$acl } )
          await this.$store.dispatch('changeCurrentOrganization', { currentOrganization: newOrg, acl: this.$acl, router: this.$router })
          if ( this.checkAccess() ) {
            if ( this.$route.name == 'page-error' ) {
              await this.$router.push({name: 'homePage' })
            } else {
              await this.$router.push({name: this.$route.name, params: {...this.$route.params, org: newOrg?.organizationItId}, query: this.$route.query })
            }
          }
        }
      } catch (failure) {
        this.$log(failure)
      }
      if ( overlay ) {
        this.$root.$emit('closeOverlay')
      }
    },
    checkAccess() {
      let settings = this.$store.getters.getSettings,
        access = settings?.userAccess,
        checkBilling = access?.checkBillingResult,
        accessType = access?.accessType,
        error_route = {name: 'page-error', params: { status_code: '403', descript: 'пусто settings.userAccess' } }

      if (!access && this.$route.name == 'login') {
        return
      }

      const changeToPublic = () => {
        // Если у пользователя нет доступа к режиму админа, меняем роль на публичную
        if (!this.$acl.check('isGoodMode')) {
          this.$acl.change('public')
        }
      }

      /** Для пользователей с доступом к функционалу админа, игнорим все ошибки */
      /*if (this.$acl.check('isGoodMode')) {
        return
      }*/

      if (!access && window.config?.node_env !== 'development') {
        changeToPublic()
        this.$router.push(error_route)
        return
      }
      if (accessType ==  'ORGANIZATION_ACCESS_ERROR') {
        this.$router.push(error_route)
        return
      } else if (
        accessType ==  'AUTHORIZATION_ERROR'
        || accessType == 'VERIFICATION_ERROR' // копанія не перевірена
        || accessType == 'IDENTIFICATION_ERROR'
        || accessType == 'ORGANIZATION_ROLE_ERROR'
        || accessType == 'CONFIGURATION_ERROR' // org 166907
      ) {
        changeToPublic()
        if (accessType == 'VERIFICATION_ERROR' // копанія не перевірена
          || accessType == 'IDENTIFICATION_ERROR') {
          error_route.params.type = accessType.replace('_', '-').toLowerCase()
        }
        this.$router.push(error_route)

        this.$store.dispatch('setMenu', { acl: this.$acl, router: this.$router })
        return
      } else if (accessType == 'BILLING_ERROR') {
        changeToPublic()
        error_route.params.type = 'low-balance'
        this.$router.push(error_route)

        this.$store.dispatch('setMenu', { acl: this.$acl, router: this.$router })
        return
      } else if (checkBilling?.showMessageByPayment) {
        this.showLowBalanceDialog = true
        this.$root.$emit('showLowBilingAlert')
      } else {
        this.showLowBalanceDialog = false
        this.$root.$emit('closeLowBilingAlert')
      }
      if (!settings?.availableOrganizations?.length  && window.config?.node_env !== 'development') {
        this.$router.push(error_route)
      }
      return true
    }
  },
}
